
import { defineComponent, ref, computed, h, VNodeChild } from "vue";
import { MdPerson } from "@vicons/ionicons4";
import { useMessage, SelectOption, NTag } from "naive-ui";
import HosterInvitePerson from "@/components/hoster/editor/hosterInvitePerson.vue";
import { useStore } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/hosterEnums";
import inviteMemberModel from "@/core/models/hoster/inviteMember.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import searchPersonCRUDModel from "@/core/models/hoster/seachPersonCRUD.interface";

import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
  Permision as ParamPermision,
} from "@/store/enums/paramsEnums";
const createData = () => [
  "Marks",
  "Catherine",
  "Ashely",
  "Patty",
  "Ken",
  "Timo",
  "YuChein",
  "Dain",
];

export default defineComponent({
  props: {
    actionModal: { type: String, required: true, default: "I" },
  },
  components: {
    MdPerson,
    HosterInvitePerson,
  },
  setup(props: any, context: any) {
    const valueRef = ref("");
    const checkBoxValueRef = ref(null);
    const store = useStore();
    const message = useMessage();
    const optionPerson = computed(
      () => store.getters[Module.desc + Getters.KeywordPersonList]
    );

    function onFoucus(param: any) {
      //console.log("onFoucus",param)
    }
    function onSelectPerson(param: invitePersonModel) {
      var mailReg =
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (mailReg.test(param.Email)) {
        store.dispatch(Module.desc + Actions.HandInivteMember, param);
      } else {
        message.error("未符合Email格式");
      }

      //store.dispatch(Module.desc + Actions.HandInivteMember, param);
    }
    function handleCheckBoxValue(value: any) {
      checkBoxValueRef.value = value;
      //message.info(JSON.stringify(value))
    }
    function getAutoCompleteShow(value: any) {
      if (value.length >= 3) {
        //超過3字元進行搜尋
        var format = /[!#$%^&*+=\[\]{};':"\\|,\/?]/;
        let data: searchPersonCRUDModel = {
          IsOutlookFormat: false,
          Data: value,
        };
        if (format.test(value)) {
          // 符合 outlook 格式
          data.IsOutlookFormat = true;
          store.dispatch(Module.desc + Actions.SearchPerson, data);
          valueRef.value = ""; // 清空 input txt
          return false; //關閉 下拉
        } else {
          // 不符合 outlook 格式
          store.dispatch(Module.desc + Actions.SearchPerson, data);
          return true;
        }
      }
      return false;
    }
    return {
      ParamPermision,
      options: optionPerson,
      valueRef,
      onFoucus,
      onSelectPerson,
      checkBoxValue: checkBoxValueRef,
      handleCheckBoxValue,
      optionPerson,
      getShow: getAutoCompleteShow,
    };
  },
});
